import React, { Component } from "react";
import ImageEditor from "@toast-ui/react-image-editor";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import download from "downloadjs";
import { Radio, Button, InputNumber, Card, message } from "antd";
import { Layout } from "./Layout";
import { Loader } from "../../components/Loader";
import { PBox, PH4, PH3, PText } from "../../theme/BaseTheme";
import { Dimension } from "../../components/app/Dimension";
import ChangePlanModal from "../../components/app/ChangePlanModal";
import PaymentConfirmModal from "../../components/app/PaymentConfirmModal";
import { fetchPattern, downloadEditedImage } from "../../../actions/pattern";
import { refetchUser } from "../../../actions/auth";
import "tui-image-editor/dist/tui-image-editor.css";
import "tui-color-picker/dist/tui-color-picker.css";

const myTheme = {
    // download button
    "downloadButton.display": "none",
    // load button
    "loadButton.display": "none",
    // header
    "header.display": "none",

    "common.bi.image":
        "https://uicdn.toast.com/toastui/img/tui-image-editor-bi.png",
    "common.bisize.width": "251px",
    "common.bisize.height": "21px",
    "common.backgroundImage": "./img/bg.png",
    "common.backgroundColor": "#fff",
    "common.border": "1px solid #c1c1c1",

    // header
    "header.backgroundImage": "none",
    "header.backgroundColor": "transparent",
    "header.border": "0px",

    // load button
    "loadButton.backgroundColor": "#fff",
    "loadButton.border": "1px solid #ddd",
    "loadButton.color": "#222",
    "loadButton.fontFamily": "'Noto Sans', sans-serif",
    "loadButton.fontSize": "12px",

    // download button
    "downloadButton.backgroundColor": "#fdba3b",
    "downloadButton.border": "1px solid #fdba3b",
    "downloadButton.color": "#fff",
    "downloadButton.fontFamily": "'Noto Sans', sans-serif",
    "downloadButton.fontSize": "12px",

    // main icons
    "menu.normalIcon.color": "#8a8a8a",
    "menu.activeIcon.color": "#555555",
    "menu.disabledIcon.color": "#434343",
    "menu.hoverIcon.color": "#e9e9e9",
    "menu.iconSize.width": "24px",
    "menu.iconSize.height": "24px",

    // submenu icons
    "submenu.normalIcon.color": "#8a8a8a",
    "submenu.activeIcon.color": "#555555",
    "submenu.iconSize.width": "32px",
    "submenu.iconSize.height": "32px",

    // submenu primary color
    "submenu.backgroundColor": "transparent",
    "submenu.partition.color": "#e5e5e5",

    // submenu labels
    "submenu.normalLabel.color": "#858585",
    "submenu.normalLabel.fontWeight": "normal",
    "submenu.activeLabel.color": "#000",
    "submenu.activeLabel.fontWeight": "normal",

    // checkbox style
    "checkbox.border": "1px solid #ccc",
    "checkbox.backgroundColor": "#fff",

    // rango style
    "range.pointer.color": "#333",
    "range.bar.color": "#ccc",
    "range.subbar.color": "#606060",

    "range.disabledPointer.color": "#d3d3d3",
    "range.disabledBar.color": "rgba(85,85,85,0.06)",
    "range.disabledSubbar.color": "rgba(51,51,51,0.2)",

    "range.value.color": "#000",
    "range.value.fontWeight": "normal",
    "range.value.fontSize": "11px",
    "range.value.border": "0",
    "range.value.backgroundColor": "#f5f5f5",
    "range.title.color": "#000",
    "range.title.fontWeight": "lighter",

    // colorpicker style
    "colorpicker.button.border": "0px",
    "colorpicker.title.color": "#000",
};

class Design extends Component {
    editorRef = React.createRef();

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            control: "design",
            usage: "pod",
            upscale: "1",
            croppedImage: null,
            dpi: "72",
            format: "png",
            width: "undefined",
            height: "undefined",
            isProcessing: false,
            isChangePlanModalOpen: false,
            isPaymentConfirmModalOpen: false,
            newPlan: "",
        };
        this.downloadImage = this.downloadImage.bind(this);
    }
    async componentDidMount() {
        await this.props.fetchPattern(this.props.match.params.pattern_uuid);
        await this.setState({ isLoading: false });
    }

    downloadImage = async () => {
        await this.setState({ isProcessing: true });
        message.open({
            type: "loading",
            content: "Preparing for downloading. This can take a while.",
            duration: 0,
        });
        const editorInstance = await this.editorRef.current.getInstance();
        let dataURL = await editorInstance.toDataURL();
        await this.props.downloadEditedImage(
            this.props.match.params.pattern_uuid,
            dataURL,
            this.state.format,
            this.state.dpi,
            this.state.width,
            this.state.height,
            this.state.upscale
        );
        message.destroy();
        await this.setState({ isProcessing: false });
    };

    render() {
        if (this.state.isLoading) {
            return <Loader />;
        }
        return (
            <Layout>
                <PBox css={styles}>
                    <PBox className="app-content">
                        <PBox className="app-content-control">
                            {this.state.control === "design" && (
                                <Card title="Edit and Download">
                                    <PBox>
                                        <PH3>Download Options</PH3>
                                        <PH4>1. Please choose a dimension.</PH4>
                                        <Radio.Group
                                            options={[
                                                {
                                                    label: "Predefined dimensions.",
                                                    value: "pod",
                                                },
                                                {
                                                    label: "Customized dimensions.",
                                                    value: "selling",
                                                },
                                            ]}
                                            value={this.state.usage}
                                            onChange={(e) => {
                                                this.setState({
                                                    usage: e.target.value,
                                                });
                                            }}
                                        />
                                        {this.state.usage === "pod" && (
                                            <Dimension
                                                setWidth={(value) => {
                                                    this.setState({
                                                        width: value,
                                                    });
                                                }}
                                                setHeight={(value) => {
                                                    this.setState({
                                                        height: value,
                                                    });
                                                }}
                                            />
                                        )}
                                        {this.state.usage === "selling" && (
                                            <>
                                                <PText>Width</PText>
                                                <InputNumber
                                                    min={1}
                                                    max={999999}
                                                    value={this.state.width}
                                                    onChange={(value) => {
                                                        this.setState({
                                                            width: value,
                                                        });
                                                    }}
                                                />{" "}
                                                px
                                                <PText>Height</PText>
                                                <InputNumber
                                                    min={1}
                                                    max={999999}
                                                    value={this.state.height}
                                                    onChange={(value) => {
                                                        this.setState({
                                                            height: value,
                                                        });
                                                    }}
                                                />{" "}
                                                px
                                            </>
                                        )}
                                    </PBox>
                                    <PBox>
                                        <PH4>
                                            2. Please choose a resolution
                                            (upscale image).
                                        </PH4>
                                        <Radio.Group
                                            value={this.state.upscale}
                                            onChange={(e) => {
                                                this.setState({
                                                    upscale: e.target.value,
                                                });
                                            }}
                                            options={[
                                                {
                                                    label: "x1 (1024px x 1024px)",
                                                    value: "1",
                                                },
                                                {
                                                    label: "x2 (2048px x 2048px)",
                                                    value: "2",
                                                },
                                                {
                                                    label: "x4 (4096px x 4096px)",
                                                    value: "4",
                                                },
                                            ]}
                                        />
                                    </PBox>
                                    <PBox>
                                        <PH4>3. Please choose a DPI.</PH4>
                                        <Radio.Group
                                            value={this.state.dpi}
                                            onChange={(e) => {
                                                this.setState({
                                                    dpi: e.target.value,
                                                });
                                            }}
                                            options={[
                                                {
                                                    label: "72 dpi",
                                                    value: "72",
                                                },
                                                {
                                                    label: "100 dpi",
                                                    value: "100",
                                                },
                                                {
                                                    label: "150 dpi",
                                                    value: "150",
                                                },
                                                {
                                                    label: "200 dpi",
                                                    value: "200",
                                                },
                                                {
                                                    label: "300 dpi",
                                                    value: "300",
                                                },
                                            ]}
                                        />
                                    </PBox>
                                    <PBox>
                                        <PH4>4. Please choose a format.</PH4>
                                        <Radio.Group
                                            value={this.state.format}
                                            onChange={(e) => {
                                                this.setState({
                                                    format: e.target.value,
                                                });
                                            }}
                                            options={[
                                                {
                                                    label: "PNG",
                                                    value: "png",
                                                },
                                                {
                                                    label: "JPEG",
                                                    value: "jpg",
                                                },
                                                {
                                                    label: "WEBP",
                                                    value: "webp",
                                                },
                                            ]}
                                        />
                                    </PBox>
                                    <PBox>
                                        <PText>
                                            <br />
                                        </PText>
                                        <Button
                                            type="primary"
                                            onClick={async () => {
                                                await this.downloadImage();
                                            }}
                                            loading={this.state.isProcessing}
                                        >
                                            Download
                                        </Button>
                                    </PBox>
                                </Card>
                            )}
                        </PBox>
                        <PBox className="app-content-crop-and-mockup">
                            <PBox className="app-content-crop">
                                {this.state.control === "design" && (
                                    <ImageEditor
                                        ref={this.editorRef}
                                        usageStatistics={false}
                                        includeUI={{
                                            loadImage: {
                                                // https://zyst.io/how-to-fix-aws-s3-chrome-and-safari-cors-on-images
                                                // https://github.com/nhn/tui.image-editor/issues/68
                                                path:
                                                    this.props.pattern?.url?.replace(
                                                        /^https:\/\//i,
                                                        "http://"
                                                    ) +
                                                    "?t=" +
                                                    new Date().getTime(),
                                                name: "PatternImage",
                                            },
                                            theme: myTheme,
                                            menu: [
                                                "crop",
                                                "flip",
                                                "rotate",
                                                "draw",
                                                "shape",
                                                "icon",
                                                "text",
                                                "mask",
                                                "filter",
                                            ],
                                            initMenu: "filter",
                                            uiSize: {
                                                width: "100%",
                                                height: "800px",
                                            },
                                            menuBarPosition: "bottom",
                                            //colorPalette: ["#ffffff", "#3c3c3c", "#234252"],
                                        }}
                                        cssMaxHeight={500}
                                        cssMaxWidth={700}
                                        selectionStyle={{
                                            cornerSize: 20,
                                            rotatingPointOffset: 70,
                                        }}
                                    />
                                )}
                            </PBox>
                        </PBox>
                        {this.state.isChangePlanModalOpen && (
                            <ChangePlanModal
                                isChangePlanModalOpen={
                                    this.state.isChangePlanModalOpen
                                }
                                handleChangePlanModalOk={async () => {
                                    await this.setState({
                                        isPaymentConfirmModalOpen: true,
                                    });
                                    await this.setState({
                                        isChangePlanModalOpen: false,
                                    });
                                }}
                                handleChangePlanModalCancel={() => {
                                    this.setState({
                                        isChangePlanModalOpen: false,
                                    });
                                }}
                                setNewPlan={(value) => {
                                    this.setState({ newPlan: value });
                                }}
                            />
                        )}

                        {this.state.isPaymentConfirmModalOpen && (
                            <PaymentConfirmModal
                                newPlan={this.state.newPlan}
                                isPaymentConfirmModalOpen={
                                    this.state.isPaymentConfirmModalOpen
                                }
                                handlePaymentConfirmModalOk={() =>
                                    this.setState({
                                        isPaymentConfirmModalOpen: false,
                                    })
                                }
                                handlePaymentConfirmModalCancel={() =>
                                    this.setState({
                                        isPaymentConfirmModalOpen: false,
                                    })
                                }
                            />
                        )}
                    </PBox>
                </PBox>
            </Layout>
        );
    }
}

const styles = {
    "& .app-content": {
        display: "grid",
        gap: "1rem",
        alignItems: "flex-start",
        gridTemplateColumns: "repeat(1, minmax(0, 1fr))",
        "@bp4": {
            gap: "2rem",
            gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
        },
        padding: "3rem 2rem",
        //maxWidth: "80rem",
        margin: "0 auto",
    },
    "& .app-content-control": {
        gridTemplateColumns: "repeat(1, minmax(0, 1fr))",
        "& h3": {
            marginTop: 0,
        },
    },
    "& .app-content-crop-and-mockup": {
        "@bp4": {
            gridColumn: "span 3 / span 3",
        },
    },
};

function mapStateToProps(state) {
    return {
        userAccount: state.authReducer?.userAuth?.userAccount,
        pattern: state.patternReducer?.fetchPattern?.pattern,
    };
}

export default connect(mapStateToProps, {
    fetchPattern,
    downloadEditedImage,
    refetchUser,
})(withRouter(Design));
